import SwipeGuide from './SwipeGuide'
import Modal from './Modal'

export default class {
  constructor() {

    const domSwipeGuide = document.querySelectorAll('[data-js="guide"]');
    if (domSwipeGuide) {
      [...domSwipeGuide].forEach(el => {
        new SwipeGuide(el);
      })
    }

    const domModal = document.querySelector('[data-js="job-modal"]');
    if (domModal) new Modal(domModal);
  }
}
